module.exports = __webpack_public_path__ + "img/placeholder_UL.3ab34a54.jpg";